import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { Button, Input } from 'reactstrap';
import { IoIosClose } from 'react-icons/io';
import { FormattedMessage } from 'react-intl';
import NormalVideoPlayer from './../Play/NormalVideoPlayer';

class VideoPlayerModal extends Component {

    constructor(props){
        super(props)
        this.state={

        }
    }

    render() {
        const {isPlaying,toggleVideoPlayer}=this.props;
        return (
            <Modal open={isPlaying}  className="playerModal">
                <div className="feedback-modal-header" >
                    <div className="feedback-modal-header-title">
                        <h3><b>
                            <FormattedMessage id="create_your_goggle"
                                defaultMessage="Create your Goggle"
                            />
                        </b></h3>
                    </div>
                    <IoIosClose onClick={toggleVideoPlayer} size={25} />
                </div>
                <div className="video-player-modal-body">
                    <NormalVideoPlayer videoUrl={"https://cdn.mobio360.com/diy/How+to+make+a+VR+headset.mp4"} />
                </div>
            </Modal>
        )
    }
}


export default VideoPlayerModal;


// WEBPACK FOOTER //
// ./src/components/Account/VideoPlayerModal.js